export const ReorderMachineDelays = {
  GROUP_ORDER_REORDER_CONFIRMATION_TIMEOUT: 30_000,
};
